import type { CourseDetailSummaryPropertyInstructorBasicInfo } from './courseDetailSummaryPropertyInstructorBasicInfo';
import type { CourseDetailSummaryPropertyInstructorSocial } from './courseDetailSummaryPropertyInstructorSocial';

/**
 * 강사 정보
 */
export type CourseDetailSummaryPropertyInstructor = {
  /** 사용자 기본 정보 */
  basicInfo: CourseDetailSummaryPropertyInstructorBasicInfo;
  /** 소셜 관계 정보 */
  social?: CourseDetailSummaryPropertyInstructorSocial;
};
